import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore.js'

const hostname = window.location.hostname
const mainHosts = ['oil-paintings.app', 'www.oil-paintings.app', 'localhost']
const isCustomDomain = !mainHosts.includes(hostname) &&
    !/^127\./.test(hostname) &&
    !/^192\.168\./.test(hostname) &&
    !/\.local$/.test(hostname)

const routes = []

if (!isCustomDomain) {
  routes.push({
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: 'Home Page', requiresAuth: true }
  })
}

routes.push(
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue'),
    meta: { title: 'Register' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: 'Login', hideNav: true }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/LogoutView.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requiresAuth: true, isAdmin: true, title: 'Admin Dashboard' },
    component: () => import('../views/admin/AdminView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { title: 'Settings', requiresAuth: true }
  },
  {
    path: '/paintings',
    name: 'paintings',
    component: () => import('../views/PaintingsView.vue'),
    meta: { title: 'My Paintings' }
  },
  {
    path: '/paintings/edit/:id',
    name: 'paintings-edit',
    component: () => import('../views/PaintingsView.vue'),
    meta: { title: 'Edit Painting', requiresAuth: true }
  },
  {
    path: '/pages',
    name: 'pages',
    component: () => import('../views/PagesView.vue'),
    meta: { title: 'My Pages', requiresAuth: true }
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('../views/ContactsView.vue'),
    meta: { title: 'Contacts', requiresAuth: true }
  },
  {
    path: '/feature-requests',
    name: 'feature-requests',
    component: () => import('../views/FeatureRequestsView.vue'),
    meta: { title: 'Feature Requests', requiresAuth: true }
  },
  {
    path: '/site/:urlName/painting/:paintSlug',
    name: 'site-paint',
    component: () => import('../views/SiteView.vue'),
    meta: { hideNav: true }
  },
  {
    path: '/site/:urlName/page/:pageToken',
    name: 'site-page',
    component: () => import('../views/SiteView.vue'),
    meta: { hideNav: true }
  },
  {
    path: '/site/:urlName',
    name: 'site',
    component: () => import('../views/SiteView.vue'),
    meta: { hideNav: true }
  },
  {
    path: '/:token/painting/:artist/:paintingSlug',
    name: 'painting-detail',
    component: () => import('../views/PaintingsView.vue'),
    props: true
  }
)

if (isCustomDomain) {
  routes.push(
    {
      path: '/',
      name: 'custom-domain-site',
      component: () => import('../views/SiteView.vue'),
      meta: { hideNav: true, isCustomDomain: true }
    },
    {
      path: '/painting/:paintSlug',
      name: 'custom-domain-paint',
      component: () => import('../views/SiteView.vue'),
      meta: { hideNav: true, isCustomDomain: true }
    },
    {
      path: '/page/:pageToken',
      name: 'custom-domain-page',
      component: () => import('../views/SiteView.vue'),
      meta: { hideNav: true, isCustomDomain: true }
    }
  )
}

const router = createRouter({
  history: createWebHistory(isCustomDomain ? '/' : process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  console.log('%c to  . (1743452975) ', 'color:lightgreen;', to)

  const store = useUserStore()

  if (to.meta.requiresAuth && store.isLoggedIn == false) return '/login'
  if (to.meta.isAdmin && store.user.role_id < 70) return '/login'

  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
